import { ComplaintsStatisticsPerPost } from 'mk2/apps/forum/schemas';
import { complaintToggle, ComplaintToggleAction } from 'mk2/containers/Complaint/Complaint.actions';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { Action } from 'redux';

export interface ForumReadFeedSaveAction extends Action {
    readonly feed: string;
}

export const FORUM_READ_FEED_REQUEST = 'FORUM_READ_FEED_REQUEST';

export interface ForumReadFeedSaveRequestAction extends ForumReadFeedSaveAction, APIRequestAction {
    readonly type: typeof FORUM_READ_FEED_REQUEST;
}

export const FORUM_READ_FEED_SUCCESS = 'FORUM_READ_FEED_SUCCESS';

export interface ForumReadFeedSaveSuccessAction extends ForumReadFeedSaveAction {
    readonly type: typeof FORUM_READ_FEED_SUCCESS;
}

export const FORUM_READ_FEED_FAILURE = 'FORUM_READ_FEED_FAILURE';

export interface ForumReadFeedSaveFailureAction extends ForumReadFeedSaveAction, APIFailureAction {
    readonly type: typeof FORUM_READ_FEED_FAILURE;
}

export const forumReadFeedSave = {
    request: (feed: string): ForumReadFeedSaveRequestAction => ({ type: FORUM_READ_FEED_REQUEST, feed }),
    success: (feed: string): ForumReadFeedSaveSuccessAction => ({ type: FORUM_READ_FEED_SUCCESS, feed }),
    failure: (feed: string, error: any): ForumReadFeedSaveFailureAction => ({ type: FORUM_READ_FEED_FAILURE, error, feed }),
};

export const FORUM_READ_FEED = 'FORUM_READ_FEED';

export interface ForumReadFeedAction extends ForumReadFeedSaveAction {
    readonly type: typeof FORUM_READ_FEED;
}

export const forumReadFeed = (feed: string): ForumReadFeedAction => ({ type: FORUM_READ_FEED, feed });

export interface ForumPostToggleNotificationsAction extends Action {}

export const FORUM_TOGGLE_NOTIFICATIONS_REQUEST = 'FORUM_TOGGLE_NOTIFICATIONS_REQUEST';
export interface ForumPostToggleNotificationsRequestAction extends ForumPostToggleNotificationsAction, APIRequestAction {
    readonly type: typeof FORUM_TOGGLE_NOTIFICATIONS_REQUEST;
}

export const FORUM_TOGGLE_NOTIFICATIONS_SUCCESS = 'FORUM_TOGGLE_NOTIFICATIONS_SUCCESS';
export interface ForumPostToggleNotificationsSuccessAction extends ForumPostToggleNotificationsAction {
    readonly type: typeof FORUM_TOGGLE_NOTIFICATIONS_SUCCESS;
    readonly follow: boolean;
    readonly channelId: number;
}

export const FORUM_TOGGLE_NOTIFICATIONS_FAILURE = 'FORUM_TOGGLE_NOTIFICATIONS_FAILURE';
export interface ForumPostToggleNotificationsFailureAction extends ForumPostToggleNotificationsAction, APIFailureAction {
    readonly type: typeof FORUM_TOGGLE_NOTIFICATIONS_FAILURE;
}

export const forumPostToggleNotificationsActions = {
    request: (): ForumPostToggleNotificationsRequestAction => ({
        type: FORUM_TOGGLE_NOTIFICATIONS_REQUEST,
    }),
    success: (follow: boolean, channelId: number): ForumPostToggleNotificationsSuccessAction => ({
        type: FORUM_TOGGLE_NOTIFICATIONS_SUCCESS, follow, channelId,
    }),
    failure: (error: any): ForumPostToggleNotificationsFailureAction => ({
        type: FORUM_TOGGLE_NOTIFICATIONS_FAILURE, error,
    }),
};

export const FORUM_POST_TOGGLE_NOTIFICATIONS = 'FORUM_POST_TOGGLE_NOTIFICATIONS';

export interface PostToggleNotificationsAction extends ForumPostToggleNotificationsAction {
    readonly type: typeof FORUM_POST_TOGGLE_NOTIFICATIONS;
    readonly username: string;
    readonly channelName: string;
    readonly channelId: number;
    readonly follow: boolean;
}

export const postToggleNotifications = (
        username: string, channelName: string, channelId: number, follow: boolean,
    ): PostToggleNotificationsAction => ({
    type: FORUM_POST_TOGGLE_NOTIFICATIONS, username, channelName, channelId, follow,
});

export const FORUM_POST_OPEN_COMPLAINT = 'FORUM_POST_OPEN_COMPLAINT';

export interface PostOpenComplaintAction extends Action {
    readonly type: typeof FORUM_POST_OPEN_COMPLAINT;
    readonly postId: number;
    readonly topicSlug: string;
    readonly postSlug: string;
}

export const postOpenComplaint = (postId: number, topicSlug: string, postSlug: string): PostOpenComplaintAction => ({
    type: FORUM_POST_OPEN_COMPLAINT, postId, topicSlug, postSlug,
});

export const FORUM_POST_SEND_HEART = 'FORUM_POST_SEND_HEART';

export interface PostSendHeartAction extends Action {
    readonly type: typeof FORUM_POST_SEND_HEART;
}

export const postSendHeart = (): PostSendHeartAction => ({
    type: FORUM_POST_SEND_HEART,
});

export interface ForumDeletePostApiAction extends Action {
    readonly id: number;
}

export const FORUM_DELETE_POST_API_REQUEST = 'FORUM_DELETE_POST_API_REQUEST';

export interface ForumDeletePostApiRequestAction extends ForumDeletePostApiAction, APIRequestAction {
    readonly type: typeof FORUM_DELETE_POST_API_REQUEST;
}

export const FORUM_DELETE_POST_API_SUCCESS = 'FORUM_DELETE_POST_API_SUCCESS';

export interface ForumDeletePostApiSuccessAction extends ForumDeletePostApiAction, APISuccessAction {
    readonly type: typeof FORUM_DELETE_POST_API_SUCCESS;
}

export const FORUM_DELETE_POST_API_FAILURE = 'FORUM_DELETE_POST_API_FAILURE';

export interface ForumDeletePostApiFailureAction extends ForumDeletePostApiAction, APIFailureAction {
    readonly type: typeof FORUM_DELETE_POST_API_FAILURE;
}

export const forumDeletePostApi = {
    request: (id: number): ForumDeletePostApiRequestAction => ({ type: FORUM_DELETE_POST_API_REQUEST, id }),
    success: (id: number, response: any): ForumDeletePostApiSuccessAction => ({ type: FORUM_DELETE_POST_API_SUCCESS, id, response }),
    failure: (id: number, error: any): ForumDeletePostApiFailureAction => ({ type: FORUM_DELETE_POST_API_FAILURE, id, error }),
};

export const FORUM_DELETE_POST = 'FORUM_DELETE_POST';

export interface ForumDeletePostAction extends ForumDeletePostApiAction {
    readonly type: typeof FORUM_DELETE_POST;
}

export const forumDeletePost = (id: number): ForumDeletePostAction => ({ type: FORUM_DELETE_POST, id });

export const FORUM_UPDATE_COMPLAINTS_STATISTICS = 'FORUM_UPDATE_COMPLAINTS_STATISTICS';

export interface ForumUpdateComplaintsStatisticsAction extends Action {
    readonly type: typeof FORUM_UPDATE_COMPLAINTS_STATISTICS;
    readonly complaintsStatistics: ComplaintsStatisticsPerPost;
}

export const forumUpdateComplaintsStatistics = (complaintsStatistics: ComplaintsStatisticsPerPost): ForumUpdateComplaintsStatisticsAction => ({
    type: FORUM_UPDATE_COMPLAINTS_STATISTICS,
    complaintsStatistics,
});

export interface LastVisitCounts {
    readonly newest: number;
    readonly popular: number;
    readonly updated: number;
    readonly subscribed: number;
}

export const FORUM_HEADER_UPDATE = 'FORUM_HEADER_UPDATE';

export interface ForumHeaderUpdateAction extends Action {
    readonly type: typeof FORUM_HEADER_UPDATE;
    readonly lastVisitCounts: LastVisitCounts;
}

export const forumHeaderUpdate = (lastVisitCounts: LastVisitCounts): ForumHeaderUpdateAction => ({ type: FORUM_HEADER_UPDATE, lastVisitCounts });
